<span class="trial-role-toggle" [class.checked]="checked" (click)="onToggle()">
  <i class="fas {{ checked ? 'fa-check' : 'fa-times' }}"></i>
</span>


